/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-state
 * OpenAPI spec version: 1.0.0
 */

/**
 * Abacus state action name
 */
export type AbacusStateActionName =
  (typeof AbacusStateActionName)[keyof typeof AbacusStateActionName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AbacusStateActionName = {
  payment_eligibility: "payment_eligibility",
  tax_eligibility: "tax_eligibility",
  approve_sales_files: "approve_sales_files",
  close_period: "close_period",
  deliver_sales_files: "deliver_sales_files",
  mark_runs_as_complete: "mark_runs_as_complete",
  prep_mechanical_deductions: "prep_mechanical_deductions",
  commit_royalties: "commit_royalties",
  legacy_sync: "legacy_sync",
  sap_sync: "sap_sync",
  banking_details_review: "banking_details_review",
  banking_eligibility: "banking_eligibility",
  generate_export: "generate_export",
  generate_payments: "generate_payments",
  send_payments: "send_payments",
  upload_approval: "upload_approval",
  calculate_payments: "calculate_payments",
  send_payment: "send_payment",
  approve_sales: "approve_sales",
  get_eligible_sales: "get_eligible_sales",
  release_reserves: "release_reserves",
  statement_period_close: "statement_period_close",
  upload_exchange_rates: "upload_exchange_rates",
  apply_file: "apply_file",
  approve_file: "approve_file",
  import_file: "import_file",
  upload_file: "upload_file",
  close_balance: "close_balance",
  collaborators_auto_report_run: "collaborators_auto_report_run",
  funds_confirmed: "funds_confirmed",
  salesforce_id_confirmed: "salesforce_id_confirmed",
  salesforce_id_linked: "salesforce_id_linked",
} as const;
